"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statistics = [{
  value: "99.9%",
  label: "Uptime Guarantee",
  description: "Enterprise-grade SSL & Cloudflare protection."
}, {
  value: "24/7",
  label: "Expert Support",
  description: "Real humans helping you grow your vision."
}, {
  value: "50+",
  label: "Global Locations",
  description: "Lightning fast edge delivery for every visitor."
}, {
  value: "100%",
  label: "Daily Backups",
  description: "Your data is secured with automated snapshots."
}];
export default function ReviewStatisticsBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257731" id="global-infrastructure" className="dark bg-background">
      <div className="bg-secondary text-foreground py-16 md:py-24 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5 pointer-events-none flex items-center justify-center">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/world_map_silhouette.png" alt="" className="w-full h-full object-cover grayscale" />
        </div>
        
        <div className="page-container relative z-10">
          <div ref={ref} className={`grid grid-cols-2 gap-8 text-center md:grid-cols-4 md:gap-12 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            {statistics.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center space-y-2 md:space-y-3">
                <span className="font-default text-4xl font-bold tracking-tighter text-primary md:text-5xl lg:text-7xl">
                  {stat.value}
                </span>
                <div className="flex flex-col space-y-1">
                  <span className="text-sm font-bold uppercase tracking-widest text-foreground md:text-base font-default">
                    {stat.label}
                  </span>
                  <span className="text-xs font-medium text-muted-foreground md:text-sm max-w-[180px] mx-auto">
                    {stat.description}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}